import { toStreamID } from './StreamID';
import { ensureValidStreamPartitionIndex } from './partition';
const DELIMITER = '#';
export function toStreamPartID(streamId, streamPartition) {
    ensureValidStreamPartitionIndex(streamPartition);
    return `${streamId}${DELIMITER}${streamPartition}`;
}
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class StreamPartIDUtils {
    static parse(streamPartIdAsStr) {
        const [streamId, streamPartition] = StreamPartIDUtils.parseRawElements(streamPartIdAsStr);
        if (streamPartition === undefined) {
            throw new Error(`invalid streamPartId string: ${streamPartIdAsStr}`);
        }
        toStreamID(streamId); // throws if not valid
        ensureValidStreamPartitionIndex(streamPartition);
        return streamPartIdAsStr;
    }
    static getStreamID(streamPartId) {
        return this.getStreamIDAndPartition(streamPartId)[0];
    }
    static getStreamPartition(streamPartId) {
        return this.getStreamIDAndPartition(streamPartId)[1];
    }
    static getStreamIDAndPartition(streamPartId) {
        return StreamPartIDUtils.parseRawElements(streamPartId);
    }
    static parseRawElements(str) {
        const lastIdx = str.lastIndexOf(DELIMITER);
        if (lastIdx === -1 || lastIdx === str.length - 1) {
            return [str, undefined];
        }
        return [str.substring(0, lastIdx), Number(str.substring(lastIdx + 1))];
    }
}
